import { combine } from 'effector';
export function and() {
  for (var _len = arguments.length, stores = new Array(_len), _key = 0; _key < _len; _key++) {
    stores[_key] = arguments[_key];
  }
  return combine({
    and: [stores, values => {
      for (var value of values) {
        if (!value) {
          return false;
        }
      }
      return true;
    }, {
      skipVoid: false
    }],
    or: {
      sid: "-rbm5ks"
    }
  });
}